import { useRef, useEffect } from 'react';
import TileImageSource from 'ol/source/TileImage';
import OLTileLayer from 'ol/layer/Tile';
import TileGrid from 'ol/tilegrid/TileGrid';
import { useOLMap } from '../MapContext';
import { useLayerEffect } from './useLayerEffect';
import { getCrossOriginValue } from './getCrossOriginValue';
export const TileArcGISLayer = (props) => {
    const map = useOLMap();
    const layerRef = useRef();
    useLayerEffect(layerRef, props.layerOptions);
    useEffect(() => {
        const urlMetadata = `${props.sourceOptions.url}?f=json`;
        const layer = new OLTileLayer({
            visible: props.layerOptions.visible,
            opacity: props.layerOptions.opacity ?? 1,
            minResolution: props.layerOptions.minResolution,
            maxResolution: props.layerOptions.maxResolution,
            zIndex: props.layerOptions.zIndex,
        });
        layerRef.current = layer;
        map.addLayer(layer);
        fetch(urlMetadata, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((data) => {
            if (data.tileInfo) {
                const projection = map.getView().getProjection();
                const sourceParams = {
                    ...props.sourceOptions,
                    attributions: props.copyright || data.copyrightText,
                    crossOrigin: getCrossOriginValue(props.sourceOptions.url),
                    projection,
                    wrapX: projection.isGlobal(),
                    tileGrid: new TileGrid({
                        origin: [data.tileInfo.origin.x, data.tileInfo.origin.y],
                        tileSize: [data.tileInfo.cols, data.tileInfo.rows],
                        extent: [
                            data.fullExtent.xmin,
                            data.fullExtent.ymin,
                            data.fullExtent.xmax,
                            data.fullExtent.ymax,
                        ],
                        resolutions: data.tileInfo.lods.reduce((ar, el) => {
                            ar.push(el.resolution);
                            return ar;
                        }, []),
                    }),
                    tileUrlFunction: (tileCoord) => {
                        return `${props.sourceOptions.url}/tile/${tileCoord[0].toString()}/${tileCoord[2].toString()}/${tileCoord[1].toString()}`;
                    },
                };
                layer.setSource(new TileImageSource(sourceParams));
                if (sourceParams.tileUrlFunction) {
                    layer.getSource().setTileUrlFunction(sourceParams.tileUrlFunction);
                }
                if (process.env.NODE_ENV === 'development') {
                    console.debug('new TileArcGISLayer', map, layerRef.current);
                }
            }
            else {
                console.error(`TileArcGIS layer (${props.id}) cannot be created due the service has no tiles definition.`);
            }
        })
            .catch((err) => {
            console.error('TileArcGIS layer: ' + err.message);
        });
        return () => {
            // unmount
            const layer = layerRef.current;
            if (layer) {
                map.removeLayer(layer);
                layer.dispose();
                layerRef.current = null;
            }
        };
    }, [map, props.sourceOptions]);
    return null;
};
//# sourceMappingURL=TileArcGISLayer.js.map